import './styles.scss';
import cx from 'classnames';
import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {Layout, Popover} from 'antd';
import {AppHeaderItemsMap, AppRoutesPathReference} from '../../../routes/RoutesRegister';
import BrowserRouter, {BrowserRoutes} from '../../../routes/BrowserRouter';
import Logo from "../../../assets/logo.png";
import {LogoutOutlined, SettingOutlined} from "@ant-design/icons";
import Button from "../../common/Button/Button";
import {useAuth0} from "@auth0/auth0-react";
import UserPicture from "../../common/UserPicture/UserPicture";
import useAppStore from "../../../data/App.store";
import useUserStore from "../../../data/User.store";

const {Header} = Layout;

interface Props extends RouteComponentProps {
    hideLogo?: boolean,
}

function AppHeader({hideLogo, location}: Props) {
    const {logout} = useAuth0();
    const {sidebarCollapsed} = useAppStore();
    const {user} = useUserStore();

    function selectedKey() {
        for (let key in AppRoutesPathReference) {
            if (location.pathname.includes(AppRoutesPathReference[key].path)) {
                return key;
            }
        }
        return '';
    }

    function menuItems() {
        return AppHeaderItemsMap.map(appRouteHeader => {
            const {key, icon, path} = appRouteHeader;
            return (
                <div key={key} onClick={() => BrowserRouter.push(path)}
                     className={cx('single-menu-item', {selected: key === selectedKey()})}>
                    {icon}
                    <span>{key}</span>
                </div>
            )
        })
    }

    function renderPopoverTitle() {
        return (
            <div className='app-sidebar-popover-title'>
                <div className='vendor'>
                    {user?.role?.name}
                </div>
                <Button icon={<LogoutOutlined/>} color='clear'
                        onClick={() => logout({returnTo: window.location.origin})}>
                    Sign Out
                </Button>
            </div>
        )
    }

    function content() {
        return (
            <div className='app-sidebar-popover-content'>
                <div className='name'>{user?.first_name} {user?.last_name}</div>
                <div className='email'>{user?.email}</div>
                <Button icon={<SettingOutlined/>} style={{marginTop:12}} onClick={() => BrowserRouter.push(BrowserRoutes.settings)}>
                    Settings
                </Button>
            </div>
        )
    }

    return (
        <Header className='app-header' style={{ position: 'fixed', zIndex: 100, width: '100%' }}>
            <div className='content'>
                <div className='app-header-left'>
                    {!hideLogo &&
                    <div className='logo' onClick={() => BrowserRouter.push(BrowserRoutes.home)}>
                        <img alt="Logo" src={Logo}/>
                    </div>}
                </div>
                <div className='full-width-menu'>
                    {menuItems()}
                </div>
                <div className='app-header-right'>
                    <Popover title={renderPopoverTitle()} content={content()} trigger={['click']} placement='bottomLeft'
                             overlayStyle={{minWidth: 400}}>
                        <div className={cx('user-container', {collapsed: sidebarCollapsed})}>
                            <UserPicture user={user}/>
                            <div className='user'>
                                <div
                                    className='name'>{user?.first_name} {user?.last_name}</div>
                                <div className='email'>{user?.email}</div>
                            </div>
                        </div>
                    </Popover>
                </div>
            </div>
        </Header>
    )
}

export default withRouter(AppHeader);
